import React from "react";
import UploadResume from "../components/UploadResume";

const Home = () => {
  return (
    <div className="home-page">
      <UploadResume />
    </div>
  );
};

export default Home;
